import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  getPhoneFilterInputValue,
  getPhoneSearchMode,
  type PhoneSearchMode,
} from "@shared/helpers/normalize-phone-for-search";
import React from "react";

export interface PhoneNumberFilterInputProps {
  value: string;
  mode: PhoneSearchMode;
  onChange: (value: string, mode: PhoneSearchMode) => void;
  label?: string;
}

export function PhoneNumberFilterInput({
  value,
  mode,
  onChange,
  label = "מספר טלפון",
}: PhoneNumberFilterInputProps) {
  return (
    <Box
      sx={{
        px: 2,
        pt: 1,
        pb: 2.5,
        minWidth: 280,
      }}
    >
      <Stack spacing={2}>
        <FormControl>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mb: 1 }}
          >
            סוג חיפוש
          </Typography>
          <RadioGroup
            row
            value={mode}
            onChange={(e) =>
              onChange(value, e.target.value as PhoneSearchMode)
            }
            sx={{ gap: 1 }}
          >
            <FormControlLabel
              value="partial"
              control={<Radio size="small" color="secondary" />}
              label="חלק ממספר"
              sx={{ mr: 2 }}
            />
            <FormControlLabel
              value="full"
              control={<Radio size="small" color="secondary" />}
              label="מספר מלא"
            />
          </RadioGroup>
        </FormControl>

        <TextField
          size="small"
          autoFocus
          value={value}
          onChange={(e) =>
            onChange(e.target.value.replace(/\D/g, ""), mode)
          }
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            style: { direction: "ltr" },
            "aria-label": label,
          }}
          placeholder={
            mode === "full" ? "0501234567" : "למשל 1234 או 50"
          }
          fullWidth
          variant="outlined"
        />

        <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.4 }}>
          {mode === "full"
            ? "הזן מספר טלפון מלא להתאמה מדויקת"
            : "הזן חלק מהמספר — לפחות 2 ספרות"}
        </Typography>
      </Stack>
    </Box>
  );
}

export function getPhoneFilterStateFromMeta(meta: Record<string, unknown>) {
  return {
    value: getPhoneFilterInputValue(meta.value as string | undefined),
    mode: getPhoneSearchMode(meta.searchMode),
  };
}
